const state = {
    comInfo: JSON.parse(sessionStorage.getItem("comInfo")) || {},
    reportStepId: sessionStorage.getItem("research_reportStepId") || [],
    declareStepStatus: sessionStorage.getItem("research_declareStepStatus") || 1,
    nowStepStatus: sessionStorage.getItem("research_nowStepStatus") || 1,
    childStepStatus: sessionStorage.getItem("research_childStepStatus") || 1
};

const mutations = {
    SET_COM_INFO: (state, comInfo) => {
        state.comInfo = comInfo;
        sessionStorage.setItem("comInfo", JSON.stringify(comInfo));
    },
    SET_REPORT_STEP_ID: (state, reportStepId) => {
        state.reportStepId = reportStepId;
        sessionStorage.setItem("research_reportStepId", reportStepId);
    },
    SET_DECLARE_STEP_STATUS: (state, declareStepStatus) => {
        state.declareStepStatus = declareStepStatus;
        sessionStorage.setItem("research_declareStepStatus", declareStepStatus);
    },
    SET_NOW_STEP_STATUS: (state, nowStepStatus) => {
        state.nowStepStatus = nowStepStatus;
        sessionStorage.setItem("research_nowStepStatus", nowStepStatus);
    },
    SET_CHILD_STEP_STATUS: (state, childStepStatus) => {
        state.childStepStatus = childStepStatus;
        sessionStorage.setItem("research_childStepStatus", childStepStatus);
    }
};

const actions = {
    setComInfo({ commit }, comInfo) {
        commit("SET_COM_INFO", comInfo);
    },
    setReportStepId({ commit }, reportStepId) {
        commit("SET_REPORT_STEP_ID", reportStepId);
    },
    setDeclareStepStatus({ commit }, declareStepStatus) {
        commit("SET_DECLARE_STEP_STATUS", declareStepStatus);
    },
    setNowStepStatus({ commit }, nowStepStatus) {
        commit("SET_NOW_STEP_STATUS", nowStepStatus);
    },
    setChildStepStatus({ commit }, childStepStatus) {
        commit("SET_CHILD_STEP_STATUS", childStepStatus);
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
